import { Dependencies } from "../../models"

export interface Benefit {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    imageUrl: string
    categoryIds: string[]
    dependencies: Dependencies | null
}

export interface BenefitListItem {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    imageUrl: string
    categoryNames: string[]
}

export interface PagedBenefit {
    items: BenefitListItem[]
    totalCount: number
}

export const BENEFIT_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    descriptions: "Opis",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    image: "Slika",
    categoryIds: "Kategorije",
    dependencies: "Ovisnosti",
}
